import getList from './getList';

export default async (options = { showError: true }) => {
    const { error, status, rows } = await getList(options);
    if (error) return { error, status };
    // 处理树结构
    const idMap = {};
    const result = [];
    for (const item of rows) {
        const { id, parentId } = item;
        idMap[id] = item;
        if (parentId !== '') {
            const parentNode = idMap[parentId];
            if (parentNode) {
                if (!parentNode.children) parentNode.children = [];
                parentNode.children.push(item);
            } else {
                result.push(item);
            }
        } else {
            // 1级
            result.push(item);
        }
    }
    return { rows: result };
};
